export const API_URL = process.env.VUE_APP_API_BASE_URL;

export const API_ENDPOINTS = {
  LOGIN: '/api/v1/user/login/',
  REFRESH_TOKEN: '/api/v1/user/refresh/',
  CURRENT_USER: '/api/v1/user/my/'
} 
